var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M10.934 6h1.988v12h-1.988z","key":0}),React.createElement("path",{"fill":"#fff","d":"M17.891 11v2H5.964v-2H17.89Z","key":1})]);
}

Plus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
